import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const darkMode = JSON.parse(localStorage.getItem('darkMode') || 'false')
    this.toggle(darkMode)
  }

  toggle(value = null) {
    const newValue = value !== null ? value : !this.element.classList.contains('dark')

    if (newValue) {
      this.element.classList.add('dark', 'bg-gray-900')
    } else {
      this.element.classList.remove('dark', 'bg-gray-900')
    }

    localStorage.setItem('darkMode', JSON.stringify(newValue))
  }

  click(event) {
    event.preventDefault()
    this.toggle()
  }
}
